import { render } from "./EventInfoDialog.vue?vue&type=template&id=0278d26d&scoped=true"
import script from "./EventInfoDialog.vue?vue&type=script&lang=js"
export * from "./EventInfoDialog.vue?vue&type=script&lang=js"

import "./EventInfoDialog.vue?vue&type=style&index=0&id=0278d26d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0278d26d"]])

export default __exports__